import { 
    GET_CONFIG_FORM34,
    GET_GASTOS_GRILLA

} from '../types';

export default function provisionGastosReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM34:
            return { ...state, cfg_form34:action.payload }
        case GET_GASTOS_GRILLA:
            return { ...state, datosGrilla:action.payload }
       
       
        default:
            return state
    }
}